import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
	const { t } = useTranslation();

	return (
		<footer className="mb-16 mt-24 lg:block relative z-10">
			<div className="max-w-screen-lg mx-auto px-6 text-center space-y-6"

            style={{ textShadow: "0 3px 10px rgba(0,0,0,0.45)" }}>

				{/* Company Info */}
				<p className="text-sm leading-relaxed text-white">
					<span className="font-semibold">Eloquent-i</span> by BYG Systems Ltd.<br />
					1-2 William Lee Buildings,<br />
					Science & Technology Park,<br />
					Nottingham, United Kingdom, NG7 2RQ
				</p>

				{/* Copyright */}
				<p className="text-xs text-white">
					{t('footer.copyright')}
				</p>

			</div>
		</footer>
	);
};

export default Footer;
